import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, currency = 'USD'): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
}

export function formatDate(date: string | Date, options?: Intl.DateTimeFormatOptions): string {
  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  return new Date(date).toLocaleDateString('en-US', options ?? defaultOptions);
}

export function getInitials(name: string): string {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function pluralize(count: number, singular: string, plural?: string): string {
  return count === 1 ? singular : (plural ?? `${singular}s`);
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str;
  return `${str.slice(0, length)}...`;
}

/**
 * Extract a display name from any user/guest object.
 * Handles both the new `name` field and legacy `firstName`/`lastName` fields
 * so pages work regardless of API response format.
 */
export function displayName(
  user: { name?: string; firstName?: string; lastName?: string } | null | undefined,
  fallback = 'Unknown'
): string {
  if (!user) return fallback;
  if (user.name) return user.name;
  const full = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return full || fallback;
}
